export const PARAM_HOST_PROFILE = 'rp'
export const PARAM_USER_GROUP = 'ug'
export const PARAM_REFERRAL_CODE = 'r'
export const PARAM_PATH = 'path'
export const PARAM_PERSONA = 'persona'
export const PARAM_UTM_CONTENT = 'utm_content'
export const PARAM_TC_ID = 'userID'
export const PARAM_GOAL = 'goal'
